export { FormComponent, type FormProps } from "./form";
